export default __webpack_public_path__ + "./fonts/FSMeWeb-Heavy.woff";